<template>
  <div class="w-screen max-w-5xl">
    <div
      class="relative flex h-full flex-col overflow-y-scroll bg-gray-50 bg-opacity-90 shadow-xl backdrop-blur-sm backdrop-opacity-90 backdrop-filter dark:bg-ontick-carbon-500"
    >
      <div class="grid grid-cols-6 text-ontick-carbon-900 dark:text-gray-300">
        <div class="hidden flex-col pt-16 pl-6 lg:flex">
          <div class="sticky top-16">
            <div class="flex flex-col space-y-10">
              <button @click="closeModal">
                <i v-html="$icons.arrow_left"></i>
              </button>
              <ontick-button
                @click.native="
                  data.valid_license_found;
                  subscribe(data.valid_license_found, data.active_for_user, data.extension_id);
                "
                :color="data.active_for_user ? 'ghost-green' : 'primary'"
                :disabled="data.active_for_user && data.extension_price > 0"
                class="space-x-2 uppercase"
              >
                <i v-html="$icons.material_check" v-if="data.active_for_user" key="1"></i>
                <span
                  v-if="
                    (data.active_for_user && !data.valid_license_found) ||
                    (data.active_for_user && data.valid_license_found)
                  "
                  key="2"
                >
                  Ativo
                </span>
                <span v-else-if="!data.active_for_user && !data.valid_license_found" key="3">
                  {{ data.extension_price ? "Contratar" : "Ativar" }}
                </span>
                <span v-else-if="!data.active_for_user && data.valid_license_found" key="3"> Reativar </span>
              </ontick-button>
            </div>
            <ul class="space-y-4 pt-10 text-sm font-medium">
              <li>
                <a class="cursor-pointer" @click="scrollToAnchorPoint('description')"> Descrição </a>
              </li>
              <li>
                <a class="cursor-pointer" @click="scrollToAnchorPoint('images')"> Imagens </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-span-6 flex flex-col space-y-10 px-6 pt-16 lg:col-span-5">
          <div class="space-y-2">
            <div class="flex flex-col space-y-6">
              <button @click="closeModal" class="lg:hidden">
                <i v-html="$icons.arrow_left"></i>
              </button>
              <div class="flex items-center space-x-4">
                <div class="w-16 overflow-hidden rounded-xl">
                  <img :src="data.extension_logo" :alt="data.extension_name" />
                </div>
                <div>
                  <h2 class="text-2xl font-semibold lg:text-4xl">
                    {{ data.extension_name }}
                  </h2>
                  <p class="flex items-center space-x-2 text-lg text-gray-500 lg:text-xl">
                    <span> Contratação: </span>
                    <plan-badge-component
                      :required_plan="data.required_plan"
                      :price="data.extension_price"
                      class="inline-block text-white"
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="space-y-2" ref="description">
            <h3 class="text-2xl lg:text-3xl" id="description">Descrição</h3>
            <p class="text-ontick-steel-500 dark:text-gray-400">
              {{ data.extension_long_desc }}
            </p>
          </div>
          <div class="space-y-2 pb-16" ref="images">
            <h3 class="text-2xl lg:text-3xl" id="images">Imagens</h3>
            <div class="overflow-hidden">
              <swiper :options="options">
                <swiper-slide v-for="(img, index) in data.extension_images" :key="index">
                  <img :src="img" alt="Imagem da extensão" />
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
          </div>
          <ontick-button
            @click.native="
              data.valid_license_found;
              subscribe(data.valid_license_found, data.active_for_user, data.extension_id);
            "
            :color="data.active_for_user ? 'ghost-green' : 'primary'"
            class="space-x-2 uppercase lg:hidden"
          >
            <i v-html="$icons.material_check" v-if="data.active_for_user" key="1"></i>
            <span v-if="data.active_for_user" key="2"> Ativo </span>
            <span v-else key="3">
              {{ data.extension_price ? "Contratar" : "Ativar" }}
            </span>
          </ontick-button>
        </div>
      </div>
    </div>
    <ontick-upgrade-modal-component
      v-model="upgradeModalData.active"
      :type="upgradeModalData.type"
      :productName="upgradeModalData.name"
      :productPlan="upgradeModalData.plan"
    />
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import aeroComponent from "@/app/shared/components/aero/aero.component";
import { mapActions, mapGetters } from "vuex";
import PlanBadgeComponent from "./plan-badge.component.vue";
import OntickUpgradeModalComponent from "../../../../shared/components/basic/ontick-upgrade-modal.component.vue";
export default {
  props: {
    show: {
      type: Boolean,
    },
  },
  components: {
    aeroComponent,
    PlanBadgeComponent,
    Swiper,
    SwiperSlide,
    OntickUpgradeModalComponent,
  },
  data() {
    return {
      data: {},
      isLoading: false,
      options: {
        loop: true,
        grabCursor: true,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      modalCustomClasses: {
        popup: "bg-ontick-graphite-600 py-10 rounded-lg",
        title: "text-gray-300 text-3xl font-bold",
        content: "text-gray-400",
        confirmButton: "bg-ontick-blue-600 py-2 px-6 text-ontick-carbon-900 confirm-button rounded-lg mx-1",
        cancelButton: "bg-transparent py-2 px-6 text-gray-300 border border-ontick-steel-400 rounded-lg mx-1",
      },
      upgradeModalData: {
        active: false,
        type: null,
        name: null,
        plan: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      getDetailsId: "extensions/getDetailsId",
      getDetailsIsActive: "extensions/getDetailsIsActive",
    }),
  },
  methods: {
    ...mapActions({
      setDetailsIsActive: "extensions/setDetailsIsActive",
      setUserConfig: "config/setUserConfig",
    }),
    closeModal() {
      this.setDetailsIsActive(false);
    },
    getData() {
      this.isLoading = true;
      this.$api
        .get(`${this.$endpoint.GET_EXTENSION_DETAILS}/${this.getDetailsId}`)
        .then((res) => {
          this.data = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName];

      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start",
      });
    },
    getConfig() {
      return new Promise((resolve, reject) => {
        this.$api
          .get(this.$endpoint.USER_CONFIGS)
          .then((response) => {
            this.setUserConfig(response.data);
            resolve();
          })
          .catch((error) => {
            if (error.data.status == "error") {
              this.setUserConfig(error.data);
            }
            reject();
          });
      });
    },
    activateExtension(id) {
      this.$api
        .post(this.$endpoint.CHECK_INVOICE, {
          invoice_type: "EXTENSION",
          extension_id: id,
        })
        .then((res) => {
          const actions = {
            INVOICE_SCREEN: () => {
              this.$router.push({
                path: "payment",
                query: {
                  type: "extensions",
                  extension_id: id,
                },
              });
            },
            SUCCESS_SCREEN: () => {
              this.$swal({
                title: "Sucesso",
                text: "Extensão adquirida com sucesso",
                icon: "success",
                iconHtml: this.$icons.swal_success,
                timer: 3000,
                timerProgressBar: true,
              });
              this.$emit("subscription");
            },
          };
          actions[res.data.action]();
        })
        .catch((err) => {
          this.$swal("Erro", err.data.msg, "error");
        });
    },
    disableExtension(id) {
      this.$api
        .post(this.$endpoint.DISABLE_EXTENSION, {
          extension_id: id,
        })
        .then((res) => {
          // console.log(res.data);
          this.$swal({
            title: "Sucesso",
            text: res.data.msg,
            icon: "success",
            iconHtml: this.$icons.swal_success,
          });
        })
        .catch((err) => {
          console.error(err);
          this.$swal("Erro", err.data.msg.charAt(0).toUpperCase() + err.data.msg.slice(1), "error");
        })
        .finally(() => {
          this.getData();
          this.$emit("subscription");
        });
    },
    reactivate(id) {
      this.$api
        .post(this.$endpoint.REACTIVATE_EXTENSION, {
          extension_id: id,
        })
        .then((res) => {
          this.$swal({
            title: "Sucesso",
            text: res.data.msg,
            icon: "success",
            iconHtml: this.$icons.swal_success,
          });
        })
        .catch((err) => {
          if (err.data.modal_action) {
            this.upgradeModalData = {
              type: err.data.modal_action,
              name: this.data.extension_name,
              active: true,
            };
          } else {
            this.$swal("Erro", err.data.msg, "error");
          }
        })
        .finally(() => {
          this.getData();
          this.$emit("subscription");
        });
    },
    subscribe(licenseFound, isActive, id) {
      if (isActive && !licenseFound) {
        this.disableExtension(id);
      } else if (!isActive && !licenseFound) {
        this.activateExtension(id);
      } else if (!isActive && licenseFound) {
        this.reactivate(id);
      } else {
        this.disableExtension(id);
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
